var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgParentPost(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 141780",
    transform: "translate(27 238.5)",
    fill: "#751bdc",
    stroke: "#707070",
    d: "M0 0h24v24H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 38882",
    transform: "translate(-21 -232.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 141779",
    width: 36,
    height: 36,
    rx: 18,
    transform: "translate(21 232.5)",
    fill: "#e6caff"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Mask Group 1535",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "invisible box"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 141781",
    fill: "none",
    d: "M27 238.5h24v24H27z"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Q3 icons"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 48359",
    d: "M40 253.5h8a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1h-8a1 1 0 0 0-1 1v1h-4v-4h3a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1h-8a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h3v13a1 1 0 0 0 1 1h5v1a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1h-8a1 1 0 0 0-1 1v1h-4v-6h4v1a1 1 0 0 0 1 1Zm1-4h6v2h-6Zm-10-8h6v2h-6Zm10 16h6v2h-6Z",
    fill: "#751bdc"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParentPost);
export default __webpack_public_path__ + "static/media/Parent_Post.3e4673e1be5ed51ef80c61cc8b92a70b.svg";
export { ForwardRef as ReactComponent };